import { type MCPServerInfo } from '../../types';

const DailymedServer: MCPServerInfo = {
  serverId: 'DAILYMED',
  name: 'DailyMed',
  slug: 'dailymed',
  description: 'DailyMed MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'mcp/dailymed:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  deprecated: true
};

export default DailymedServer;
